import React, { Fragment, useEffect, useState } from 'react';
import Button from '../../../components/button/Button';
import Toolbar from '../../../components/toolbar/Toolbar';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { StateModel } from '../../../redux/store';
import { AdresseModel } from '../../../models/AdresseModel';
import {
  createAdresse,
  getAdresseById,
  getAdresseCopyByAdresseId,
  resetAdresserfassung,
  setAdresseField,
  updateAdresse,
} from '../../../redux/actions/adresserfassung';
import Vr from '../../../components/vr/vr';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import Allgemein from './allgemein/Allgemein';
import Anschrift from './anschrift/Anschrift';
import Kontakt from './kontakt/Kontakt';
import { LandModel } from '../../../models/LandModel';
import { Adresse, MandantSummary } from '../../../api';
import Select from '../../../components/select/Select';
import { getMandantenByHauptmandant } from '../../../redux/actions/mandant';
import { History } from 'history';

import { nameof } from '../../../utils/objectUtils';
import { toSelectOptions } from '../../../components/select/SelectModel';
import { removeNotifications } from '../../../utils/notificationUtils';
import { ConfigModel } from '../../../models/ConfigModel';

interface AdresserfassungProps {
  adresse: AdresseModel;
  laender: LandModel[];
  getAdresseById: (id: number) => void;
  getAdresseCopyByAdresseId: (id: number) => void;
  resetAdresserfassung: () => void;
  createAdresse: (
    payload: Adresse,
    copyid?: number | undefined,
    history?: History
  ) => void;
  updateAdresse: (id: number, payload: Adresse, history: History) => void;
  setAdresseField: (value: any, fieldname: string) => void;
  isHauptmandant: boolean;
  mandanten: MandantSummary[];
  getMandantenByHauptmandant: () => void;
  history: History;
  config: ConfigModel;
}

const Adresserfassung = (props: AdresserfassungProps & RouteComponentProps) => {
  const [mandanten, setMandanten] = useState<MandantSummary[]>([]);

  useEffect(() => {
    props.getMandantenByHauptmandant();

    const adresseId = location.pathname.split('/')[4];
    if (!!props.adresse.copyId) {
      props.getAdresseCopyByAdresseId(props.adresse.copyId);
    } else if (
      !!adresseId &&
      (props.adresse.id === undefined ||
        props.adresse.id.toString() !== adresseId)
    ) {
      props.getAdresseById(Number(adresseId));
    }
  }, []);

  useEffect(() => {
    setMandanten(props.mandanten);
  }, [props.mandanten]);

  const saveAdresse = () => {
    removeNotifications();
    props.adresse.id
      ? props.updateAdresse(props.adresse.id, props.adresse, props.history)
      : props.createAdresse(props.adresse, props.adresse.copyId, props.history);
  };

  return (
    <Fragment>
      <div className={`adresserfassung-wrapper`}>
        <Toolbar>
          <Button
            tooltip={'Speichern'}
            key={0}
            classes={'iconButton'}
            onClickHandler={() => saveAdresse()}
            disabled={
              !!props.adresse.inUebertragung &&
              !props.config.isAdresseUnsichtbarEdit &&
              !props.config.isAdresseKontaktEdit &&
              !props.config.isAdresseEinmaladresseEdit &&
              !props.config.isAdresseTelefonEdit &&
              !props.config.isShowTTMailAdress
            }
          >
            <i className='far fa-save fa-2x' />
          </Button>
          <Button
            tooltip='Abbrechen'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => props.resetAdresserfassung()}
          >
            <i className='fas fa-times fa-2x color-red' />
          </Button>
          {props.isHauptmandant && (
            <Select
              className='adr-mandant'
              headerTitle='Mandant'
              onChangeHandler={(id?: number) => {
                const mandant = props.mandanten.find(
                  mandant => mandant.id === id
                );
                props.setAdresseField(mandant, nameof<Adresse>('mandant'));
              }}
              selectedOptionId={props.adresse.mandant?.id ?? undefined}
              selectData={toSelectOptions(
                mandanten,
                nameof<MandantSummary>('name')
              )}
            />
          )}
        </Toolbar>

        <div className='status'>
          {props.adresse.matchcode && (
            <Fragment>
              <Vr />
              <span>
                Matchcode: <strong>{props.adresse.matchcode}</strong>
              </span>
              {props.adresse.inUebertragung && (
                <Fragment>
                  <Vr />
                  <span>
                    Status:{' '}
                    <b>
                      <i>
                        Die Eingaben in den Bereichen Allgemein und Anschrift
                        können nicht bearbeitet werden. Bitte diese Adresse
                        kopieren und dann Änderungen an der neuen Adresse
                        vornehmen.
                      </i>
                    </b>
                  </span>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
        <GridCellWrapper classes='allgemein' label='Allgemein'>
          <Allgemein />
        </GridCellWrapper>
        <GridCellWrapper classes='anschrift' label='Anschrift'>
          <Anschrift />
        </GridCellWrapper>
        <GridCellWrapper classes='kontakt' label='Kontakt'>
          <Kontakt />
        </GridCellWrapper>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  adresse: state.Adresserfassung,
  laender: state.Stammdaten.laender,
  activeTab: state.Routing.activeTab,
  isHauptmandant: state.UserSession.isHauptmandant,
  mandanten: state.Stammdaten.mandanten,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getAdresseById,
  getAdresseCopyByAdresseId,
  resetAdresserfassung,
  createAdresse,
  updateAdresse,
  setAdresseField,
  getMandantenByHauptmandant,
})(withRouter(Adresserfassung));
